import React from 'react';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import EditRolePage from './EditRolePage';
import { isEqual, cloneDeep } from 'lodash';
import permissionsActions from '../../../../../actions/permissions.actions';
import { bindActionCreators } from 'redux';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import helper from '../../../../../utils/helper';
import { generalActions } from '../../../../../actions/general.action';
import { withTranslation } from 'react-i18next';

class EditRole extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: {},
      role: {},
      getRoleError: {},
      loading: false,
      isSubmitting: false,
      errors: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.role !== prevState.role) {
      state.role = nextProps.configure.role;
    }
    if (nextProps.configure.getRoleError !== prevState.getRoleError) {
      state.getRoleError = nextProps.configure.getRoleError;
    }
    if (nextProps.permissions.permissions !== prevState.permissions) {
      state.permissions = nextProps.permissions.permissions;
    }
    state.errors = helper.centralizeError([
      nextProps.permissions.errors,
      nextProps.configure.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    const { roleId } = this.props.match.params;
    this.setState({ loading: true }, async () => {
      this.props.generalActions.clearError();
      await this.props.configureActions
        .getSpecificRole(roleId)
        .then(
          async (role) =>
            await this.props.permissionsActions
              .getPermissionsByRole(role.name)
              .finally(() => this.setState({ loading: false })),
        );
    });
  }
  formatDataset = (groups, checked = []) => {
    if (groups.length) {
      groups.map((group) => {
        group.label = group.displayName;
        group.value = group.name.replace(/\./g, '_');
        group.title = this.props.t(helper.getRoleTooltip(group.name));
        if (group.permissions) {
          group.children = [...group.permissions];
        }
        if (group.isGranted) {
          checked.push(group.value);
        }
        delete group.displayName;
        delete group.name;
        delete group.permissions;
        if (group.children) {
          if (group.children.length) {
            this.formatDataset(group.children, checked);
          } else {
            delete group.children;
          }
        }
      });
      return [groups, checked];
    }
    return [[], []];
  };

  formatPermissions = (permissions, p, _p = []) => {
    permissions.map((permission) => {
      if (!permission['permissions']) {
        if (p.includes(permission.name)) {
          _p.push({
            name: permission.name,
            isGranted: true,
          });
        } else {
          if (permission.children.length) {
            if (permission.children.filter((x) => p.includes(x.name)).length) {
              _p.push({
                name: permission.name,
                isGranted: true,
              });
            } else {
              _p.push({
                name: permission.name,
                isGranted: false,
              });
            }
          } else {
            _p.push({
              name: permission.name,
              isGranted: false,
            });
          }
        }
      }
      if (permission.permissions && permission.permissions.length) {
        this.formatPermissions(permission.permissions, p, _p);
      }
      if (permission.children && permission.children.length) {
        this.formatPermissions(permission.children, p, _p);
      }
    });
    return _p;
  };

  onEditRole = (params) => {
    const _checked = cloneDeep(params.checked).map(
      (_p) => (_p = _p.replace(/\_/g, '.')),
    );
    const permissions = this.formatPermissions(
      cloneDeep(this.state.permissions.groups),
      _checked,
    );
    const { roleId } = this.props.match.params;
    const { concurrencyStamp, isStatic } = this.state.role;
    this.setState({ isSubmitting: true }, async () => {
      if (isStatic) {
        await this.props.permissionsActions
          .updatePermissions(params.name, { permissions })
          .then(
            async () =>
              await this.props.permissionsActions.getCurrentUserPermissions(),
          )
          .then(() =>
            this.setState({ isSubmitting: false }, () =>
              this.props.history.push('/configure/roles'),
            ),
          )
          .catch(() => this.setState({ isSubmitting: false }));
      } else {
        await this.props.configureActions
          .editRole(roleId, {
            name: params.name,
            isDefault: false,
            isPublic: false,
            concurrencyStamp,
            extraProperties: {
              description: params.description,
            },
          })
          .then(
            async () =>
              await this.props.permissionsActions
                .updatePermissions(params.name, { permissions })
                .then(
                  async () =>
                    await this.props.permissionsActions.getCurrentUserPermissions(),
                )
                .then(() =>
                  this.setState({ isSubmitting: false }, () =>
                    this.props.history.push('/configure/roles'),
                  ),
                ),
          )
          .catch(() => this.setState({ isSubmitting: false }));
      }
    });
  };
  render() {
    const { permissions, loading, role } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    let _permissions = [];
    let checked = [];
    if (Object.keys(permissions).length) {
      [_permissions, checked] = this.formatDataset(
        cloneDeep(permissions.groups),
      );
    }
    const form = {
      name: role.name,
      description: role.extraProperties && role.extraProperties.description,
      checked,
    };
    return (
      <EditRolePage
        {...this.state}
        form={form}
        permissions={_permissions}
        onEditRole={this.onEditRole}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    permissions: state.permissions,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    permissionsActions: bindActionCreators(
      Object.assign({}, permissionsActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('app')(EditRole));
